import { h, Component } from 'preact';
import { Router } from 'preact-router';

import Header from './header';
import { Link } from 'preact-router/match';
import SuperChat from './chat';

import Cart from './cart';
// Code-splitting is automated for routes
import Home from '../routes/shop';
import Chat from '../routes/chat';
import Stuff from '../routes/stuff';
import Jobs from '../routes/jobs';
import Shop from '../routes/shop';
import Videos from '../routes/videos';
import Music from '../routes/music';
import SongPage from '../routes/song-page/';
import VideoPage from '../routes/video-page';
import Tour from '../routes/tour';
import Work from '../routes/work';
import Contact from '../routes/subscribe';
import Product from '../routes/product'
import Info from '../routes/info'
import Collections from '../routes/collections'
import PropTypes from 'prop-types';
import CustomerAuthWithMutation from '../components/cart/CustomerAuth';

import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import {
  createCheckout,
  fetchCheckout,
  checkoutLineItemsAdd,
  checkoutLineItemsUpdate,
  checkoutLineItemsRemove,
	checkoutCustomerAssociate,
	addVariantToCart,
  updateLineItemInCart,
  removeLineItemInCart,
  associateCustomerCheckout
} from '../routes/shop/checkout';
import _ from 'lodash'

export const colabId = 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0LzM3NTM2MTE5MTk0MTM='
export const acneId = 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0LzM3NTM1OTc1OTk3OTc='
export const slingId = 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0LzM3Mzc2NzA4MTE3MDE='
import sanityClient from '@sanity/client'

const client = sanityClient({
	projectId: 'c0gz53p1',
	dataset: 'production',
	useCdn: false,
})

// add the load screen to the product page with map

class App extends Component {
	constructor() {
    super();

    this.state = {
      isCartOpen: false,
      isCustomerAuthOpen: false,
      isNewCustomer: false,
      currentUrl: window.location.href,
      classUrl: window.location.pathname,
      products: [],
      checkout: { lineItems: { edges: [] } }
    };

    this.handleCartClose = this.handleCartClose.bind(this);
    this.handleCartOpen = this.handleCartOpen.bind(this);
    this.openCustomerAuth = this.openCustomerAuth.bind(this);
    this.closeCustomerAuth = this.closeCustomerAuth.bind(this);
    this.addVariantToCart = addVariantToCart.bind(this);
    this.updateLineItemInCart = updateLineItemInCart.bind(this);
    this.removeLineItemInCart = removeLineItemInCart.bind(this);
    this.showAccountVerificationMessage = this.showAccountVerificationMessage.bind(this);
    this.associateCustomerCheckout = associateCustomerCheckout.bind(this);
	}

	static propTypes = {
    data: PropTypes.shape({
      loading: PropTypes.bool,
      error: PropTypes.object,
      shop: PropTypes.object,
    }).isRequired,
    createCheckout: PropTypes.func.isRequired,
    checkoutLineItemsAdd: PropTypes.func.isRequired,
    checkoutLineItemsUpdate: PropTypes.func.isRequired
  }

  componentDidMount() {
    // check local storage if cart id -> fetch by it
    // otherwise create new
    const id = localStorage.getItem('checkoutId')
    
    if (id) {
      this.props.client.query({
        query: fetchCheckout,
        variables: {
          id
        }
      })
      .then(res => {
        const isCompleted = Boolean(res.data.node && res.data.node.completedAt)

        // if completed -> remove from localstorage and create a new one
        if (isCompleted || !res.data.node) {
          localStorage.removeItem('checkoutId')
          this.createCheckout()
        } else {
          this.setState({
            checkout: res.data.node
          });
        }
      })
    } else {
      this.createCheckout()
    }
  }
  
  createCheckout = () => {
    this.props.createCheckout({
      variables: {
        input: {}
      }})
      .then((res) => {
        localStorage.setItem('checkoutId', res.data.checkoutCreate.checkout.id)
        this.setState({
          checkout: res.data.checkoutCreate.checkout
        });
    });
  }

	handleCartOpen() {
    this.setState({
      isCartOpen: true,
    });
  }

  handleCartClose() {
    this.setState({
      isCartOpen: false,
    });
  }

  openCustomerAuth(event) {
    if (event.target.getAttribute('data-customer-type') === "new-customer") {
      this.setState({
        isNewCustomer: true,
        isCustomerAuthOpen: true
      });
    } else {
      this.setState({
        isNewCustomer: false,
        isCustomerAuthOpen: true
      });
    }
  }

  showAccountVerificationMessage(){
    this.setState({ accountVerificationMessage: true });
    setTimeout(() => {
     this.setState({
       accountVerificationMessage: false
     })
   }, 5000);
  }

  closeCustomerAuth() {
    this.setState({
      isCustomerAuthOpen: false,
    });
  }
	
  componentWillReceiveProps = (nextProps) => {
    if (!_.isEqual(this.props.data.shop, nextProps.data.shop) &&
      nextProps.data && nextProps.data.shop &&
      nextProps.data.shop.collections.edges[0].node.products &&
      nextProps.data.shop.collections.edges[0].node.products.pageInfo.hasNextPage
    ) {
      const length = nextProps.data.shop.collections.edges[0].node.products.edges.length
      const lastItem = nextProps.data.shop.collections.edges[0].node.products.edges[length - 1]

      nextProps.data.fetchMore({
        variables: {
          after: this.cursor || lastItem.cursor,
        },
        updateQuery: (prev, { fetchMoreResult, ...rest }) => {
          if (!fetchMoreResult) return prev;
          const length = fetchMoreResult.shop.collections.edges[0].node.products.edges.length
          const lastItem = fetchMoreResult.shop.collections.edges[0].node.products.edges[length - 1]
          if (lastItem) {
            this.cursor = lastItem.cursor
          } else {
            this.cursor = null
          }
          
          return {
            ...fetchMoreResult,
            shop: {
              ...fetchMoreResult.shop,
              collections: {
                ...fetchMoreResult.shop.collections,
                edges: [
                  {
                    ...fetchMoreResult.shop.collections.edges[0],
                    node: {
                      ...fetchMoreResult.shop.collections.edges[0].node,
                      products: {
                        ...fetchMoreResult.shop.collections.edges[0].node.products,
                        edges: [
                          ...prev.shop.collections.edges[0].node.products.edges,
                          ...fetchMoreResult.shop.collections.edges[0].node.products.edges
                        ]
                      },
                    }
                  }
                ]
              }
            },
          };
        }
      })
    }
  }
	
	/** Gets fired when the route changes.
	 *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
	 *	@param {string} event.url	The newly routed URL
	 */
	handleRoute = e => {
    this.currentUrl = e.url;
    window.scrollTo(0, 0);
		document.body.scrollTop = 0;
    this.setState({currentUrl: e.url});

	};

	render() {
    let data = this.props.data

    if (data.shop && data.shop.collections) {
      data = {
        ...data,
        shop: {
          ...data.shop,
          products: data.shop.collections.edges[0].node.products
        }
      }
    } else {
      data = {
        ...data,
        shop: {
          ...data.shop,
          products: {
            edges: []
          }
        }
      }
    }

		return (
			<div id="app" class={this.state.currentUrl.slice(1).replace(/\//g, '-')}>
      <header>
				<Header />

        <div>
          
        {!this.state.isCartOpen &&
            <div className="App__view-cart-wrapper">
              <button className="App__view-cart button App__customer-actions" onClick={()=> this.setState({isCartOpen: true})}>Cart</button>
            </div>
          }
      
    
        </div>
        
        </header>
				{/*<SuperChat />
				<Cart />*/}
				<Cart
          clearCheckout={this.createCheckout}
          removeLineItemInCart={this.removeLineItemInCart}
          updateLineItemInCart={this.updateLineItemInCart}
          checkout={this.state.checkout}
          isCartOpen={this.state.isCartOpen}
          handleCartClose={this.handleCartClose}
          customerAccessToken={this.state.customerAccessToken}
        />
				<div className="Flash__message-wrapper">
          <p className={`Flash__message ${this.state.accountVerificationMessage ? 'Flash__message--open' : ''}`}>We have sent you an email, please click the link included to verify your email address</p>
        </div>
        <CustomerAuthWithMutation
          closeCustomerAuth={this.closeCustomerAuth}
          isCustomerAuthOpen={this.state.isCustomerAuthOpen}
          newCustomer={this.state.isNewCustomer}
          associateCustomerCheckout={this.associateCustomerCheckout}
          showAccountVerificationMessage={this.showAccountVerificationMessage}
        />
		
				<Router onChange={this.handleRoute}>
        <Home path="/" {...this.props} {...this.state} addVariantToCart={this.addVariantToCart} data={data}/>

		    <Videos  path="/videos/:slug?" sanity={client} />
					<VideoPage  path="/video/:slug" sanity={client} /> 
				
					{/* <Music  path="/music" sanity={client} /> */}
          <Contact  path="/make"  />
        	{/* <SongPage path="/:slug" sanity={client} /> */}
      		<Shop path="/buy/" {...this.props} {...this.state} addVariantToCart={this.addVariantToCart} data={data}/>
					<Product path="/:handle" {...this.props} addVariantToCart={this.addVariantToCart} {...this.state} data={data} />
				</Router>
			</div>
		);
	}
}
// this can be helpful in the future
// this is where u enter collection id
// https://help.shopify.com/en/api/graphql-admin-api/reference/object/order
const query = gql`
  query query($after: String) {
    shop {
      name
      collections(first:1, query:"title:hat-supply"){
        edges{
          node{
            products(first:10, after: $after, sortKey: MANUAL) {
              pageInfo {
                hasNextPage
                hasPreviousPage
              }
              edges {
                cursor
                node {
                  availableForSale 
                  description
                  descriptionHtml
                  id
                  title
                  handle
                  tags
                  options {
                    id
                    name
                    values
                  }
                  variants(first: 250) {
                    pageInfo {
                      hasNextPage
                      hasPreviousPage
                    }
                    edges {
                      node {
                        availableForSale
                        id
                        title
                        selectedOptions {
                          name
                          value
                        }
                        image(maxWidth: 500) {
                          src: transformedSrc(maxWidth: 1200)
                          gallery: transformedSrc(maxWidth: 800)
                          zoom: transformedSrc(maxWidth: 1000)
                        }
                        price
                      }
                    }
                  }
                  images(first: 250, maxWidth: 1200) {
                    pageInfo {
                      hasNextPage
                      hasPreviousPage
                    }
                    edges {
                      node {
                        src: transformedSrc(maxWidth: 1200)
                        gallery: transformedSrc(maxWidth: 800)
                        zoom: transformedSrc(maxWidth: 1000)
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const AppWithDataAndMutation = compose(
	graphql(query, {
    props: props => {
      let data = props.data

      if (data.shop && data.shop.collections) {
        data = {
          ...data,
          shop: {
            ...data.shop,
            products: data.shop.collections.edges[0].node.products
          }
        }
      } else {
        data = {
          ...data,
          shop: {
            ...data.shop,
            products: {
              edges: []
            }
          }
        }
      }

      return ({
        ...props,
        data
      })
    }
  }),
	graphql(createCheckout, {name: "createCheckout"}),
	graphql(checkoutLineItemsAdd, {name: "checkoutLineItemsAdd"}),
	graphql(checkoutLineItemsUpdate, {name: "checkoutLineItemsUpdate"}),
	graphql(checkoutLineItemsRemove, {name: "checkoutLineItemsRemove"}),
	graphql(checkoutCustomerAssociate, {name: "checkoutCustomerAssociate"})
)(App);

export default AppWithDataAndMutation



// WEBPACK FOOTER //
// ./components/app.js